var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{class:_vm.dataField['class'],style:(_vm.dataField['style'])},[_vm._v(_vm._s(_vm.dataField.title ? _vm.dataField.title : ""))])])}
var staticRenderFns = []

export { render, staticRenderFns }